import { ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { trustBadges } from "@/data/numbers";

export const Vision = () => {
  return (
    <section className="bg-ivory py-24 sm:py-36" data-testid="european-vision">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-sans-ui text-[11px] tracking-mega text-ink/40 mb-8">CAPITOLO 07 — INFRASTRUTTURA EUROPEA</p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-light text-ink text-4xl sm:text-6xl lg:text-7xl leading-[1.04] tracking-tight max-w-4xl">
            Un'infrastruttura europea per costruire brand fashion senza stock.
          </h2>
        </Reveal>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 mt-14">
          <Reveal delay={0.1}>
            <p className="font-sans-ui text-base sm:text-lg text-ink/70 leading-relaxed">
              My Brand Online nasce con una missione precisa: permetterti di creare e far crescere il tuo brand
              senza dover costruire contemporaneamente un magazzino, una struttura di fulfillment e un reparto logistico.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p data-testid="vision-hubs" className="font-sans-ui text-base sm:text-lg text-ink/70 leading-relaxed">
              My Brand Online opera attraverso i propri hub logistici a Valencia e Milano. Da qui gestiamo
              preparazione, branding e spedizioni verso i clienti in tutta Europa.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 font-display italic text-2xl sm:text-3xl text-ink leading-snug max-w-3xl">
            Scegli i prodotti. Costruisci la tua collezione. Vendi con la tua identità. Noi prepariamo ogni ordine
            e lo spediamo direttamente al tuo cliente, in tutta Europa.
          </p>
        </Reveal>

        <Reveal delay={0.05}>
          <ul data-testid="trust-badges" className="mt-14 flex flex-wrap gap-3">
            {trustBadges.map((b) => (
              <li key={b} className="inline-flex items-center gap-2 border border-ink px-4 py-2.5 font-sans-ui text-[10px] tracking-mega text-ink bg-ivory">
                <ShieldCheck size={13} strokeWidth={1.5} className="text-goldtan" /> {b.toUpperCase()}
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.05}>
          <div className="mt-16 sm:mt-24 border-y hairline py-14 grid sm:grid-cols-3 gap-8 sm:gap-4">
            {["Un catalogo.", "Una grande infrastruttura.", "Migliaia di possibili brand."].map((t) => (
              <p key={t} className="font-display font-light text-3xl sm:text-4xl lg:text-5xl text-ink leading-tight">{t}</p>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <p className="mt-14 font-sans-ui text-sm sm:text-base text-ink/55 max-w-2xl leading-relaxed">
            Una sola infrastruttura, costruita per lavorare dietro brand diversi in tutta Europa.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
